import { PspContext } from "@/config/contexts";
import { useContext } from "react";
import { MfaSetupContext } from "../../useMfaSetup";
import { translate } from "@/config/translator";
import { toast } from "react-toastify";

type UseMfaEndSuccessParams = {
  onNext: () => void;
  mfaSetupContext: MfaSetupContext;
};

export function useMfaEndSuccess({
  onNext,
  mfaSetupContext,
}: UseMfaEndSuccessParams) {
  const { lang, onMfaMethodCreatedRef } = useContext(PspContext);

  function onNextWrapper() {
    if (mfaSetupContext.newMethod) {
      onMfaMethodCreatedRef?.current?.(mfaSetupContext.newMethod);
      onNext();
    } else {
      toast(translate("somethingWentWrong", lang));
    }
  }

  return { lang, onNextWrapper };
}
